import * as React from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { Box, Typography, Button } from '@mui/material'
import { ContentStandardsChangelistResp } from './types'
import { changelistAtom } from './atoms'
import { downloadFile, openInNewTab } from 'shared/utils/fileExport'

interface ChangelistViewProps {
  state: string
  subject: string
  edgateSubject: string | null
}

const getChangelistCounts = (
  changelist: ContentStandardsChangelistResp | null,
) => {
  const { adds, updates, unchanged } = changelist?.data?.changelist || {}
  return {
    adds: adds?.length || 0,
    updates: updates?.length || 0,
    unchanged: unchanged?.length || 0,
  }
}

const downloadJson = (
  data: ContentStandardsChangelistResp['data'],
  state: string,
  subject: string,
  edgateSubject: string | null,
) => {
  const fileName = `changelist_${state.replace(/\s+/g, '_')}_${subject.replace(/\s+/g, '_')}_${(edgateSubject || 'unknown').replace(/\s+/g, '_')}.json`
  downloadFile({
    fileName,
    fileDataString: JSON.stringify(data, null, 2),
    fileDataType: 'data:text/json;charset=utf-8',
  })
}

export const ChangelistView: React.FC<ChangelistViewProps> = ({
  state,
  subject,
  edgateSubject,
}) => {
  const [changelist] = useAtom(changelistAtom)

  const counts = getChangelistCounts(changelist)

  const handleDownload = () => {
    if (changelist?.data) {
      downloadJson(changelist.data, state, subject, edgateSubject)
    }
  }

  const handleOpen = () => {
    if (changelist?.data) {
      openInNewTab({ data: changelist.data })
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body2" color="text.secondary">
        State: {state}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Kiddom Subject: {subject}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        EdGate Subject: {edgateSubject || 'N/A'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Standards to add: {counts.adds}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Standards to update: {counts.updates}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Standards unchanged: {counts.unchanged}
      </Typography>
      <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
        <Button
          variant="text"
          size="small"
          onClick={handleOpen}
          disabled={!changelist?.data}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          Open JSON
        </Button>
        <Button
          variant="text"
          size="small"
          onClick={handleDownload}
          disabled={!changelist?.data}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          Download JSON
        </Button>
      </Box>
    </Box>
  )
}
